export const pub_api = process.env.REACT_APP_FIREBASE_CONFIG === 'production'
    ? 'https://publishing-api-u7wfvp56wa-ew.a.run.app/api'
    : process.env.REACT_APP_FIREBASE_CONFIG === 'localhost'
        ? 'http://localhost:2021/api'
        : 'https://publishing-api-pj2r6ugwdq-ew.a.run.app/api';
